// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-businessServices-services-bsBom3-Bom3Positions-cellComponents-Cell2ReadonlyText-module__box--IVD6f {
  padding: 7px 12px;
  min-height: 32px;
  overflow: hidden;
  border-radius: 4px;
  border: thin solid #d9d9d9;
  background: #f5f5f5;
}
.src-businessServices-services-bsBom3-Bom3Positions-cellComponents-Cell2ReadonlyText-module__box--IVD6f img {
  max-width: 76px;
  max-height: 76px;
}
`, "",{"version":3,"sources":["webpack://./src/businessServices/services/bsBom3/Bom3Positions/cellComponents/Cell2ReadonlyText.module.less"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,gBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,0BAAA;EACA,mBAAA;AAAF;AAPA;EAUI,eAAA;EACA,gBAAA;AAAJ","sourcesContent":[".box {\n  padding: 7px 12px;\n  min-height: 32px;\n  overflow: hidden;\n\n  border-radius: 4px;\n  border: thin solid #d9d9d9;\n  background: #f5f5f5;\n\n  img {\n    max-width: 76px;\n    max-height: 76px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"box": `src-businessServices-services-bsBom3-Bom3Positions-cellComponents-Cell2ReadonlyText-module__box--IVD6f`
};
export default ___CSS_LOADER_EXPORT___;
